import { FieldDescriptor } from '../../common/FormField';
import {PrevCustElem, PrevServElem, PrevServElemDTO} from "./types";

export const useFieldsPrevCustElem1 = (): FieldDescriptor<PrevCustElem>[] => {
  return [

  {
      name: "flgprevcons",
      label: "FlagPrevCons",
      type: "autocomplete",
      boxSize: "40%",
      options: [
          { label: 'Preventivo', value: 'P' },
          { label: 'Consuntivo', value: 'C' },
          { label: 'Formazione/Golive', value: 'F' },
      ],
      optionLabelKey: "label",
      optionValueKey: "value",
      // onChange: (_, value: number ) => { setIdanagraficaSel(value);}
    },

];

};

export const useFieldsPrevCustElem2 = (): FieldDescriptor<PrevCustElem>[] => {
  return [

  { name: 'desareacust', label: 'Area Cliente', type: 'string',boxSize: '25%' },
  { name: 'codareacust', label: 'Cod. Area', type: 'string',boxSize: '25%' },

];

};
export const useFieldsPrevCustElem3 = (): FieldDescriptor<PrevCustElem>[] => {
  return [
      { name: 'desmodcust', label: 'Modulo Cliente', type: 'string',boxSize: '25%' },
 { name: 'codmodcust', label: 'Cod. Modulo', type: 'string',boxSize: '25%' },


  ];
};

export const useFieldsPrevCustElem4 = (): FieldDescriptor<PrevCustElem>[] => {
  return [

  {name: 'numanalisi', label: 'Analisi', type: 'number',boxSize: '20%' },
  { name: 'numconf', label: 'Configurazione', type: 'number',boxSize: '20%' },
  { name: 'numform', label: 'Formazione', type: 'number',boxSize: '20%' },
  { name: 'numtot', label: 'Totale', type: 'number',boxSize: '20%', disabled: true },
  { name: 'numprep', label: 'Prep', type: 'number',boxSize: '20%'},
];

};

export const useFieldsPrevCustElem5 = (): FieldDescriptor<PrevCustElem>[] => {
  return [
  { name: 'note', label: 'Note', type: 'textarea', rows: 5, multiline:true },
];

};


export const useFieldsPrevServElem1 = (): FieldDescriptor<PrevServElemDTO>[] => {
  return [
      { name: 'codarea', label: 'Cod. Area', type: 'string',boxSize: '25%', disabled: true },
  { name: 'desarea', label: 'Area Cliente', type: 'string',boxSize: '75%',disabled: true },

];

};

export const useFieldsPrevServElem2 = (): FieldDescriptor<PrevServElemDTO>[] => {
  return [
        { name: 'codmodulo', label: 'Cod. Modulo', type: 'string',boxSize: '25%',disabled: true },
        { name: 'desmodulo', label: 'Modulo Cliente', type: 'string',boxSize: '75%',disabled: true },

  ];
};


export const useFieldsPrevServElem3 = (): FieldDescriptor<PrevServElemDTO>[] => {
  return [
      { name: 'desservelem', label: 'Service Element', type: 'string',boxSize: '100%',disabled: true },

  ];
};

export const useFieldsPrevServElem4 = (): FieldDescriptor<PrevServElem>[] => {
  return [

  { name: 'numanalisi', label: 'Analisi', type: 'number',boxSize: '20%' },
  { name: 'numconf', label: 'Configurazione', type: 'number',boxSize: '20%' },
  { name: 'numform', label: 'Formazione', type: 'number',boxSize: '20%' },
  { name: 'numtot', label: 'Totale', type: 'number',boxSize: '20%', disabled: true },
  { name: 'numprep', label: 'Prep', type: 'number',boxSize: '20%'},
];

};

export const useFieldsPrevServElem5 = (): FieldDescriptor<PrevServElem>[] => {
  return [
  { name: 'note', label: 'Note', type: 'textarea', rows: 5, multiline:true },
];

};
